import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/Cards1.module.scss'
import styles2 from './../style/NalichnikiPreimushestva.module.scss'

import { Container, Image } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'

class NalichnikiPreimushestva extends React.Component {
  
  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {

    const { list, title, rtext } = this.props

    return (
      <section className={`${styles.section}`}>
        <Container>
          {title != `` &&
            <WhiteBlockTitle
              title={title}
              text={rtext}
              className={styles.title}
            />
          }
          <div className={`${styles.list} ${styles[`grid-3`]}`}>
            {list.map( ( elm, k ) => {
              return (
                <div className={styles2.block}>
                  <div className={`${styles.block} ${styles[`bg-1`]}`}>
                    <div className={styles.b_title_2}>
                      <div className={styles.b_icon}>
                        <Image src={elm?.icon} width={21} height={21} alt={elm?.name} />
                      </div>
                      <div className={styles.b_title_sep} />
                      <div>{`[Причина №${k + 1}]`}</div>
                    </div>
                    <div className={styles.b_title_t_2} dangerouslySetInnerHTML={{__html: elm?.name}} />
                    <div className={styles.b_text} dangerouslySetInnerHTML={{__html: elm?.text}} />
                    <div className={styles2.sep} />
                    <div className={styles2.btext}>Самодельные наличники</div>
                  </div>
                  <div className={`${styles.block} ${styles[`bg-1`]} ${styles2.block2}`}>
                    <div className={styles2.block2_icon}>
                      <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.50015 0.750343L6.50014 14.2497M6.50014 14.2497L11.8999 8.84993M6.50014 14.2497L1.10042 8.84993" stroke="white" strokeLinecap="round"/>
                      </svg>
                    </div>
                    <div className={styles.b_title_2}>
                      <div className={`${styles.b_title_t_2} ${styles2.title}`}>Решение</div>
                      <div className={styles.b_title_sep} />
                      <div>{this.formatSlideNumber(k)}</div>
                    </div>
                    <div className={styles.b_text} dangerouslySetInnerHTML={{__html: elm?.text2}} />
                    <div className={styles2.sep} />
                    <div className={styles2.btext}>Наличники GOODWIN</div>
                  </div>
                </div>
              )
            })}
          </div>
        </Container>
      </section>
    )
  }
}

NalichnikiPreimushestva.propTypes = {
  list: PropTypes.array,
  title: PropTypes.string,
  rtext: PropTypes.string
}

NalichnikiPreimushestva.defaultProps = {
  list: [],
  title: ``,
  rtext: ``
}

export default NalichnikiPreimushestva